import Keycloak from 'keycloak-js';

const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

if (!keycloakUrl) {
    throw new Error(
        'A variável REACT_APP_KEYCLOAK_URL não está configurada.'
    );
}

if (!keycloakRealm) {
    throw new Error(
        'A variável REACT_APP_KEYCLOAK_REALM não está configurada.'
    );
}

if (!keycloakClientId) {
    throw new Error(
        'A variável REACT_APP_KEYCLOAK_CLIENT_ID não está configurada.'
    );
}

const keycloak = new Keycloak({
    url: keycloakUrl,
    realm: keycloakRealm,
    clientId: keycloakClientId,
});

export default keycloak;